// 全局安全版 Quick Add JS - 更新为加购成功刷新购物车 + 同步选中值显示 + 动态禁用缺货选项
if (!window.quickAddEventBound) {
  window.quickAddEventBound = true;

  document.addEventListener('DOMContentLoaded', () => {
    // 监听 select 变化，同步更新显示 + 动态库存
    document.querySelectorAll('.quick-add-form').forEach(form => {
      const selects = Array.from(form.querySelectorAll('.variant-option-select'));
      const addButton = form.querySelector('[type="submit"]');
      const container = form.closest('.quick-add-variants');
      if (!container) return;

      const productId = container.dataset.productId;
      const variantsDataScript = container.querySelector(
        `.product-variants-data[data-product-id="${productId}"]`
      );
      if (!variantsDataScript) return;
      const variants = JSON.parse(variantsDataScript.textContent);

      // 匹配选项对应变体
      function findVariantByOptions(selectedOptions) {
        return variants.find(v =>
          v.options.every((opt, idx) => opt === selectedOptions[idx])
        );
      }

      //  动态更新下拉的可用性
      function updateSelectAvailability() {
        selects.forEach((select, idx) => {
          const currentValue = select.value;

          select.querySelectorAll('option').forEach(option => {
            const testOptions = selects.map((s, i) =>
              i === idx ? option.value : s.value
            );
            const variant = findVariantByOptions(testOptions);

            if (variant && variant.available) {
              option.disabled = false;
              option.classList.remove('sold-out');
              option.textContent = option.textContent.replace(' - Sold Out', '');
            } else {
              option.disabled = true;
              if (!option.textContent.includes(' - Sold Out')) {
                option.textContent += ' - Sold Out';
              }
              option.classList.add('sold-out');
            }
          });

          // 当前选项如果失效则自动切回第一个可用项
          const currentOption = select.querySelector(`option[value="${currentValue}"]`);
          if (currentOption && currentOption.disabled) {
            const firstAvailable = select.querySelector('option:not([disabled])');
            if (firstAvailable) select.value = firstAvailable.value;
          }
        });
      }

      // 🆕 检查当前组合库存状态，控制按钮是否可用
      function updateVariantState() {
        const selectedOptions = selects.map(s => s.value);
        const matchedVariant = findVariantByOptions(selectedOptions);

        if (matchedVariant && matchedVariant.available) {
          addButton.disabled = false;
          addButton.classList.remove('disabled');
        } else {
          addButton.disabled = true;
          addButton.classList.add('disabled');
        }

        updateSelectAvailability();
      }

      // select 变化时：更新显示 + 更新库存状态
      selects.forEach(select => {
        select.addEventListener('change', () => {
          const labelSpan = select.closest('.variant_item').querySelector('.selected-value');
          if (labelSpan) labelSpan.textContent = select.value;
          updateVariantState();
        });
      });

      // ✅ 初始化执行一次
      updateVariantState();
    });

    // 打开 Quick Add 面板
    document.querySelectorAll('.product-card-wrapper').forEach(productBtn => {
      const quickAddBtn = productBtn.querySelector('.quick-add-variants-btn');
      const quickAddForm = productBtn.querySelector('.quick-add-variants');
      const quickAddClose = productBtn.querySelector('.quick-add_close');

      if (!quickAddBtn || !quickAddForm) return;
      quickAddBtn.addEventListener('click', () => {
        quickAddForm.style.display = 'block';
      });
      quickAddClose.addEventListener('click', () => {
        quickAddForm.style.display = 'none';
      });
    });

    // 监听 Quick Add 提交
    document.addEventListener('submit', async e => {
      const form = e.target.closest('.quick-add-form');
      if (!form) return;

      e.preventDefault();

      const container = form.closest('.quick-add-variants');
      if (!container) return;

      const productId = container.dataset.productId;
      const variantsDataScript = container.querySelector(
        `.product-variants-data[data-product-id="${productId}"]`
      );
      if (!variantsDataScript) return;

      const variants = JSON.parse(variantsDataScript.textContent);
      const selects = Array.from(form.querySelectorAll('.variant-option-select'));
      const selectedOptions = selects.map(s => s.value);

      const matchedVariant = variants.find(v =>
        v.options.every((opt, index) => opt === selectedOptions[index])
      );

      if (!matchedVariant) {
        alert('请选择有效的产品选项');
        return;
      }
      if (!matchedVariant.available) {
        alert('该组合已售罄');
        return;
      }

      const variantId = matchedVariant.id.toString();

      // 同步 selected-value
      selects.forEach((s, idx) => {
        const labelSpan = s.closest('.variant_item').querySelector('.selected-value');
        if (labelSpan) labelSpan.textContent = selectedOptions[idx];
      });

      try {
        const res = await fetch('/cart/add', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: [{ id: variantId, quantity: 1 }],
            sections: ['cart-drawer', 'cart-icon-bubble'],
            sections_url: window.location.pathname
          })
        });

        const data = await res.json();
        const drawer = document.querySelector('cart-drawer');
        if (!drawer) return;

        if (drawer.renderContents) drawer.renderContents(data);
        drawer.classList.remove('is-empty');
        if (drawer.open) drawer.open();

      } catch (err) {
        console.error(err);
        alert('加入购物车失败');
      }
    });
  });
}
